import {
  faCube,
  faDesktop,
  faForward,
  faGear,
  faMobileScreen,
  faServer,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import React, { useContext, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { FaCode } from "react-icons/fa";
import VisibilitySensor from "react-visibility-sensor";
import angular from "../../assets/images/angular.png";
import bootstrap from "../../assets/images/bootstrap.png";
import cordova from "../../assets/images/cordova.png";
import csharp from "../../assets/images/csharp.png";
import docker from "../../assets/images/docker.png";
import aws from "../../assets/images/aws.png";
import express from "../../assets/images/express.png";
import flutter from "../../assets/images/flutter.png";
import git from "../../assets/images/git.png";
import java from "../../assets/images/java.png";
import jquery from "../../assets/images/jquery.png";
import js from "../../assets/images/js.png";
import kubernates from "../../assets/images/kubernates.png";
import laravel from "../../assets/images/laravel.png";
import loader from "../../assets/images/loaderdb.svg";
import mongodb from "../../assets/images/mongodb.png";
import mysql from "../../assets/images/mysql.png";
import next from "../../assets/images/next.png";
import node from "../../assets/images/node.png";
import php from "../../assets/images/php.png";
import plesk from "../../assets/images/plesk.png";
import python from "../../assets/images/python.png";
import react from "../../assets/images/react.png";
import spring from "../../assets/images/spring.png";
import three from "../../assets/images/three.png";
import ts from "../../assets/images/ts.png";
import unity from "../../assets/images/unity.png";
import { Context } from "../../context";
import Spacer from "../Utils/Spacer";
import CardSkill from "./CardSkill";
import classes from "./CarSkill.module.css";
import ContainerCardSkill from "./ContainerCardSkill";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
const { width, height } = getWindowDimensions();

function ControlledTabs() {
  const [keyTab, setKeyTab] = useState("backend");

  const [isVisible, setIsVisible] = useState(false);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const { debug, lang } = useContext(Context);

  if (debug) {
    console.log("render skill");
  }

  return (
    <>
      <Container fluid className={classes.bg9}>
        <div className={classes.skillsTopContainer}>
          <div className={classes.skillsTopContainer1}>
            <div className={classes.notebookContainer}>
              <div className={classes.loadingContainer}>
                <img src={loader} alt="Loading" style={{ width: "80px" }} />
              </div>
              <motion.iframe
                src="https://notebook.davidebalice.dev/"
                title="notebook"
                className={classes.notebookFrame}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  duration: 0.5,
                  ease: "easeInOut",
                  delay: 4,
                }}
              />
            </div>
          </div>

          <div className={classes.skillsTopContainer2}>
            <p className={classes.textSkillsTop}>
              <div className={classes.textSkillsTop1}>
                <FaCode /> <span>Skills</span>
              </div>

              {lang === "en" && (
                <>
                  <p className="mt-3">
                    Regardless of the technology used, I adapt to new languages,
                    frameworks or techniques in a short time, respecting the
                    team's guidelines. I attend many online courses that allow
                    me to update or improve my knowledge. I'm generally quick to
                    learn new technologies and be productive.
                  </p>
                </>
              )}
              {lang === "it" && (
                <>
                  <p className="mt-3">
                    Indipendentemente dalla tecnologia utilizzata, mi adeguo a
                    nuovi linguaggi, framework o tecniche in breve tempo,
                    rispettando le linee guida del team. Frequento molti corsi
                    online che mi permettono di aggiornare o migliorare le mie
                    conoscenze. In genere sono veloce nell'apprendere nuove
                    tecnologie ed essere produttivo.
                  </p>
                </>
              )}
            </p>
          </div>
        </div>

        <Spacer height={10} />

        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faServer} />
                    </div>
                    <div className={classes.titleText}>Backend</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-5 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" && (
                        <>
                          Experience with server-side programming languages such
                          as Php, Node.js, Java.
                          <br />
                          Knowledge of RESTful architectures e API for building
                          scalable web services.
                          <br />
                          Competence in using backend frameworks like Express,
                          Laravel or Spring. Ability to manage relational
                          databases (MySQL, PostgreSQL) and NoSQL databases
                          (such as MongoDB) for management some data.
                        </>
                      )}
                      {lang === "it" && (
                        <>
                          Esperienza con linguaggi di programmazione server-side
                          come Php, Node.js, Java.
                          <br />
                          Conoscenza delle architetture RESTful e API per la
                          creazione di servizi web scalabili.
                          <br />
                          Competenza nell'utilizzo di framework backend come
                          Express, Laravel o Spring. Capacità di gestire
                          database relazionali (MySQL, PostgreSQL) e database
                          NoSQL (come MongoDB) per la gestione dei dati.
                        </>
                      )}
                    </p>
                  </div>

                  <VisibilitySensor
                    onChange={changeVisibility}
                    partialVisibility
                    delayedCall
                  >
                    <ContainerCardSkill>
                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill text="php" classCard="php" img={php} />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.4 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="laravel"
                          classCard="laravel"
                          img={laravel}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.6 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill text="mysql" classCard="mysql" img={mysql} />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.8 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill text="node.js" classCard="node" img={node} />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 1 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="express"
                          classCard="express"
                          img={express}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 1.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="mongo db"
                          classCard="mongodb"
                          img={mongodb}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 1.4 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="spring"
                          classCard="spring"
                          img={spring}
                        />
                      </motion.div>
                    </ContainerCardSkill>
                  </VisibilitySensor>

                  <Spacer height="50" />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <Spacer height={50} />

        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faDesktop} />
                    </div>
                    <div className={classes.titleText}>Frontend</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-5 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" && (
                        <>
                          Mastery of HTML, CSS and JavaScript for creating web
                          pages, responsive and intuitive user interfaces.
                          <br />
                          Knowledge of frontend frameworks like React, Angular
                          for building dynamic user experiences.
                          <br />
                          Ability to manage application state using libraries
                          such as Redux Ability to optimize web page performance
                          to improve loading and user experience.
                          <br />
                          Understanding of user interface (UI) and user
                          experience (UX) design principles to create attractive
                          and easy to use products.
                          <br />
                          Ability to collaborate with designers to translate
                          design concepts into functional code.
                        </>
                      )}
                      {lang === "it" && (
                        <>
                          Padronanza di HTML, CSS e JavaScript per la creazione
                          di pagine web, interfacce utente responsive e
                          intuitive.
                          <br />
                          Conoscenza dei framework frontend come React, Angular
                          per la creazione di esperienze utente dinamiche.
                          <br />
                          Abilità nella gestione dello stato dell'applicazione
                          utilizzando librerie come Redux, capacità di
                          ottimizzare le prestazioni delle pagine web per
                          migliorare il caricamento e l'esperienza dell'utente.
                          <br />
                          Comprensione dei principi di design dell'interfaccia
                          utente (UI) e dell'esperienza utente (UX) per creare
                          prodotti attraenti e facili da usare.
                          <br />
                          Capacità di collaborare con designer per tradurre i
                          concept di design in codice funzionale.
                        </>
                      )}
                    </p>
                  </div>

                  <VisibilitySensor
                    onChange={changeVisibility}
                    partialVisibility
                    delayedCall
                  >
                    <ContainerCardSkill>
                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="react.js"
                          classCard="react"
                          img={react}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="next.js"
                          classCard="nextjs"
                          img={next}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="angular.js"
                          classCard="angular"
                          img={angular}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="javascript"
                          classCard="js"
                          img={js}
                          blackText
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill text="typescript" classCard="ts" img={ts} />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="jquery"
                          classCard="jquery"
                          img={jquery}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="bootstrap"
                          classCard="bootstrap"
                          img={bootstrap}
                        />
                      </motion.div>

                      <div className={classes.CardExternal}></div>
                    </ContainerCardSkill>
                  </VisibilitySensor>

                  <Spacer height="50" />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <Spacer height={50} />

        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faMobileScreen} />
                    </div>
                    <div className={classes.titleText}>App</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-5 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" && (
                        <>
                          Mobile app development using frameworks like Flutter
                          and React Native.
                          <br />
                          Ability to create consistent user interfaces on
                          different platforms (iOS, Android) while maintaining
                          an experience high quality user.
                          <br />
                          Knowledge of security practices within apps mobile,
                          including user authentication and security data.
                        </>
                      )}
                      {lang === "it" && (
                        <>
                          Sviluppo di app mobili utilizzando framework come
                          Flutter e React Native.
                          <br />
                          Abilità nella creazione di interfacce utente coerenti
                          su diverse piattaforme (iOS, Android) mantenendo
                          un'esperienza utente di alta qualità.
                          <br />
                          Conoscenza delle pratiche di sicurezza nell'ambito
                          delle app mobili, inclusa l'autenticazione utente e la
                          protezione dei dati.
                        </>
                      )}
                    </p>
                  </div>

                  <VisibilitySensor
                    onChange={changeVisibility}
                    partialVisibility
                    delayedCall
                  >
                    <ContainerCardSkill>
                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="flutter"
                          classCard="flutter"
                          img={flutter}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.4 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="react native"
                          classCard="react"
                          img={react}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.6 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="cordova"
                          classCard="express"
                          img={cordova}
                        />
                      </motion.div>

                      <div className={classes.CardExternal}></div>
                    </ContainerCardSkill>
                  </VisibilitySensor>

                  <Spacer height="50" />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <Spacer height={50} />

        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faCube} />
                    </div>
                    <div className={classes.titleText}>Web 3D</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-5 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" && (
                        <>
                          I've always been passionate about 3D. I have
                          experience in modeling using Blender, and in the past,
                          I also worked with 3D Studio.
                          <br />
                          I’ve brought my passion for 3D to the web by
                          developing applications with Three.js and React Fiber.
                          <br />
                          Additionally, I have developed various game prototypes
                          using the Unity game engine, which utilizes C# as its
                          language, and I built the gameplay mechanics and enemy
                          AI from scratch.
                        </>
                      )}
                      {lang === "it" && (
                        <>
                          Sono appassionato di 3d da sempre, ho una conoscenza
                          di modellazione tramite Blender, in passato ho
                          utilizzato 3d Studio.
                          <br />
                          Ho trasportato la mia passione per il 3d sul web
                          sviluppando applicazioni con Three.js e React Fiber.
                          <br />
                          Ho inoltre sviluppato vari prototipi di videogiochi
                          con il game engine Unity che utilizza c# come
                          linguaggio, e sviluppando da zero le logiche di
                          gameplay ed ia dei nemici.
                          <br />
                        </>
                      )}
                    </p>
                  </div>

                  <VisibilitySensor
                    onChange={changeVisibility}
                    partialVisibility
                    delayedCall
                  >
                    <ContainerCardSkill>
                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="three.js"
                          classCard="three"
                          img={three}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.4 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="react fiber"
                          classCard="react"
                          img={react}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.8 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="unity"
                          classCard="express"
                          img={unity}
                        />
                      </motion.div>

                      <div className={classes.CardExternal}></div>
                    </ContainerCardSkill>
                  </VisibilitySensor>

                  <Spacer height="50" />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <Spacer height={50} />

        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faGear} />
                    </div>
                    <div className={classes.titleText}>DevOps</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-5 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" && (
                        <>
                          Skills in versioning tools like Git, deploy su AWS
                          cloud or other providers. I use Plesk panel, Docker,
                          base knowledge of Linux systems and web server
                          management via command line.
                        </>
                      )}
                      {lang === "it" && (
                        <>
                          Competenze in strumenti di versionamento come Git,
                          deploy su cloud AWS o altri provider, utilizzo
                          pannello Plesk, Docker, conoscenze di base dei sistemi
                          Linux e gestione di web server tramite terminale.
                        </>
                      )}
                    </p>
                  </div>

                  <VisibilitySensor
                    onChange={changeVisibility}
                    partialVisibility
                    delayedCall
                  >
                    <ContainerCardSkill>
                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="plesk"
                          classCard="express"
                          img={plesk}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.4 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="aws"
                          classCard="express"
                          img={aws}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.6 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill text="git" classCard="git" img={git} />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.8 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="docker"
                          classCard="docker"
                          img={docker}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 1 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="kubernates"
                          classCard="kubernates"
                          img={kubernates}
                        />
                      </motion.div>
                    </ContainerCardSkill>
                  </VisibilitySensor>

                  <Spacer height="50" />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <Spacer height={50} />

        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faForward} />
                    </div>
                    <div className={classes.titleText}>Other</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-5 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" && (
                        <>
                          In the past I have explored various technologies, both
                          for work purposes and for pleasure, I have created
                          several video game prototypes in Unity, developing
                          mechanics and logic in C#, data processing tests in
                          Python and small software in Java. Furthermore, in the
                          past I have used obsolete technologies such as ASP and
                          Flash.
                        </>
                      )}
                      {lang === "it" && (
                        <>
                          In passato ho esplorato diverse tecnologie, sia per
                          scopi lavorativi, che per diletto, ho realizzato
                          diversi prototipi di videogiochi in Unity sviluppando
                          meccaniche e logiche in C#, test di data processing in
                          Phyton e piccoli software in Java. Inoltre in passato
                          ho utilizzato tecnologie ormai obsolete come Asp e
                          Flash.
                        </>
                      )}
                    </p>
                  </div>

                  <VisibilitySensor
                    onChange={changeVisibility}
                    partialVisibility
                    delayedCall
                  >
                    <ContainerCardSkill>
                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="python"
                          classCard="python"
                          img={python}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="c sharp"
                          classCard="csharp"
                          img={csharp}
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill text="java" classCard="java" img={java} />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, y: 12 }}
                        animate={{
                          opacity: isVisible ? 1 : 0,
                          y: isVisible ? 0 : 20,
                        }}
                        transition={{ duration: 0.4, delay: 0.2 }}
                        className={classes.CardExternal}
                      >
                        <CardSkill
                          text="unity"
                          classCard="express"
                          img={unity}
                        />
                      </motion.div>
                    </ContainerCardSkill>
                  </VisibilitySensor>
                </Col>
              </Row>
              <Spacer height="90" />
            </Container>
          </div>
        </div>
        <Spacer height="90" />
      </Container>
    </>
  );
}

export default ControlledTabs;
